import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00c95a46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = {
  key: 0,
  class: "videos"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "mask"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]

import { useInfo } from '@/store';
import PlayBtn from './PlayBtn.vue';
import { Status } from '@/types/enums';
import { formatYearDate } from '@/hooks/useTransformTime';
import { computed } from 'vue';
import { useImgSrc } from './useBaseImg';
interface VideoItem {
  coverLandscape: string;
  coverPortrait: string;
  status: Status;
  youtubeId: string;
  title: string;
  unlockTime: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Videos',
  props: {
    choesnVideo: null,
    videos: null,
    choesnVideoIndex: null
  },
  emits: ['chooseVideo', 'chooseVideoIndex'],
  setup(__props: any) {

_useCssVars(_ctx => ({
  "5e66acd9": (_unref(lockFrame).pc),
  "3adb4c88": (_unref(lockFrame).mobile),
  "ad4b311c": (_unref(unlockFrame).pc),
  "19ce12a1": (_unref(unlockFrame).mobile),
  "33fe7c68": (_unref(unlockFrameActive).pc)
}))



const images = useImgSrc();
const imagesSrcList = Object.values(images).reduce((acc: string[], curr ) => {
  return [...acc, curr.pc, curr.mobile];
}, []);
const { getImg } = useInfo();
const lock = getImg('anniversary_mobile_ingame_lock');
const lockFrame = computed(() => ({
  pc: `url(${getImg('anniversary_pc_lock_frame')})`,
  mobile: `url(${getImg('anniversary_mobile_lock_frame')})`,
}));
const unlockFrame = computed(() => ({
  pc: `url(${getImg('anniversary_pc_unlock_frame')})`,
  mobile: `url(${getImg('anniversary_mobile_unlock_frame')})`,
}));
const unlockFrameActive = computed(() => ({
  pc: `url(${getImg('anniversary_pc_unlock_frame_active')})`,
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "bg--pc",
        src: __props.choesnVideo.coverLandscape,
        alt: ""
      }, null, 8, _hoisted_2),
      _createElementVNode("img", {
        class: "bg--mobile",
        src: __props.choesnVideo.coverPortrait,
        alt: ""
      }, null, 8, _hoisted_3)
    ]),
    (__props.choesnVideo.status === _unref(Status).Open)
      ? (_openBlock(), _createBlock(PlayBtn, {
          key: 0,
          cover: __props.choesnVideo.coverLandscape,
          "youtube-id": __props.choesnVideo.youtubeId
        }, null, 8, ["cover", "youtube-id"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(__props.choesnVideo.title), 1),
      (__props.videos.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.videos, (video, index) => {
              return (_openBlock(), _createElementBlock("button", {
                key: index,
                class: _normalizeClass([
          'video',
          { 'video--chosen': index === __props.choesnVideoIndex },
        ]),
                onClick: ($event: any) => (_ctx.$emit('chooseVideo', video), _ctx.$emit('chooseVideoIndex', index)),
                type: "button"
              }, [
                _createElementVNode("img", {
                  class: "cover",
                  src: video.coverLandscape,
                  alt: ""
                }, null, 8, _hoisted_8),
                (index !== __props.choesnVideoIndex)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      (video.status === _unref(Status).Close)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("img", {
                              src: _unref(lock) || '',
                              alt: ""
                            }, null, 8, _hoisted_10),
                            _createElementVNode("time", null, _toDisplayString(_unref(formatYearDate)(video.unlockTime)), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_7))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(imagesSrcList), (item, index) => {
      return (_openBlock(), _createElementBlock("img", {
        style: {"display":"none"},
        key: index,
        src: item || undefined,
        alt: ""
      }, null, 8, _hoisted_11))
    }), 128))
  ], 64))
}
}

})